import './Page.css';

export const Page = (props: any) => {

  const {
    children,
    className
  } = props;

  return (
    <div className={`page ${className}`}>
      {children}
    </div>
  );

}